import React, { useEffect, useState }from 'react';
import { Grid, TextField, Typography, Paper, MenuItem, Divider, Box } from '@material-ui/core';
import { PARENTESCOS_BIENESTAR } from '../../../helper';
import { useTheme } from '@material-ui/core/styles';
import { cargarCatalogo } from '../../components/CargarCatalogoBienestar';

/* =======================
    STEP 1 — Información del Interesado y Representante
   ======================= */
function DatosIdentificacion({ state, onChange, solicitud }) {
    const safeValue = (field) => (state?.[field]?.valor || '');
    const safeError = (field) => (state?.[field]?.error || '');
    const theme = useTheme();
    const esMenor = safeValue('es_menor') === 'SI';
    const [parentesco, setParentesco] = useState([]);



    useEffect(() => {
        if (solicitud?.usuario_registro) {

            const usuario = solicitud.usuario_registro;

            const nombreCompleto = `
                ${usuario.primer_nombre || ''} 
                ${usuario.segundo_nombre || ''} 
                ${usuario.primer_apellido || ''} 
                ${usuario.segundo_apellido || ''}
            `.replace(/\s+/g, ' ').trim();

            onChange({
                target: {
                    name: 'nombre_desistente',
                    value: nombreCompleto
                }
            });

            onChange({
                target: {
                    name: 'documento_identidad',
                    value: usuario.identificacion || ''
                }
            });

            onChange({
                target: {
                    name: 'contacto_desistente',
                    value: usuario.celular || usuario.telefono || ''
                }
            });
        }

    const cargarTodo = async () => {
        await Promise.all([
            cargarCatalogo(PARENTESCOS_BIENESTAR, setParentesco),
        ]);
        };
        cargarTodo();
    }, [solicitud]);

    return (
        <Grid container spacing={3}>

            {/* Datos del Desistente */}
            <Grid item xs={12} md={6}>
                <TextField
                    fullWidth
                    disabled
                    label="Nombre Completo"
                    name="nombre_desistente"
                    value={safeValue('nombre_desistente')}
                    error={!!safeError('nombre_desistente')}
                    helperText={safeError('nombre_desistente')}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    fullWidth
                    disabled
                    label="No. de Documento"
                    name="documento_identidad"
                    value={safeValue('documento_identidad')}
                    onChange={onChange}
                    error={!!safeError('documento_identidad')}
                    helperText={safeError('documento_identidad')}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    fullWidth
                    label="Donde fue expedido"
                    name="lugar_expedicion_desistente"
                    value={safeValue('lugar_expedicion_desistente')}
                    error={!!safeError('lugar_expedicion_desistente')}
                    helperText={safeError('lugar_expedicion_desistente')}
                    onChange={onChange}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    fullWidth
                    label="Número de contacto"
                    name="contacto_desistente"
                    value={safeValue('contacto_desistente')}
                    error={!!safeError('contacto_desistente')}
                    helperText={safeError('contacto_desistente')}
                    onChange={onChange}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    select fullWidth
                    label="¿Es menor de edad?"
                    name="es_menor"
                    value={safeValue('es_menor')}
                    error={!!safeError('es_menor')}
                    helperText={safeError('es_menor')}
                    onChange={onChange}
                >
                    <MenuItem value="NO">No</MenuItem>
                    <MenuItem value="SI">Sí</MenuItem>
                </TextField>
            </Grid>

{esMenor && (
    <>
        <Grid item xs={12}>
            <Typography variant="subtitle2" style={{ color: theme.palette.primary.main, fontWeight: 'bold' }}>
                ANEXO 1: DATOS DEL REPRESENTANTE LEGAL (MENOR DE EDAD)
            </Typography>
        </Grid>

        <Grid item xs={12} md={6}>
            <TextField
                fullWidth
                label="Representante de (Él / la) estudiante:"
                name="nombre_representante"
                value={safeValue('nombre_representante')}
                error={!!safeError('nombre_representante')}
                helperText={safeError('nombre_representante')}
                onChange={onChange}
            />
        </Grid>

        <Grid item xs={12} md={6}>
            <TextField
                fullWidth
                label="Parentesco (ej. Madre/Padre)"
                name="parentesco_representante"
                value={safeValue('parentesco_representante')}
                onChange={onChange}
                select
                error={!!safeError('parentesco_representante')}
                helperText={safeError('parentesco_representante')}
            >
            {parentesco.map((opcion) => (
                <MenuItem key={opcion.value} value={opcion.label}>
                    {opcion.label}
                </MenuItem>
            ))}
            </TextField>
        </Grid>

        <Grid item xs={12} md={6}>
            <TextField
                fullWidth
                label="C.C. del Representante"
                name="documento_representante"
                value={safeValue('documento_representante')}
                error={!!safeError('documento_representante')}
                helperText={safeError('documento_representante')}
                onChange={onChange}
            />
        </Grid>

        <Grid item xs={12} md={6}>
            <TextField
                fullWidth
                label="Expedida en"
                name="lugar_expedicion_representante"
                value={safeValue('lugar_expedicion_representante')}
                error={!!safeError('lugar_expedicion_representante')}
                helperText={safeError('lugar_expedicion_representante')}
                onChange={onChange}
            />
        </Grid>
    </>
)}

            <Grid item xs={12}>
                <Paper elevation={0} style={{ padding: 15, backgroundColor: '#f9f9f9', borderLeft: `4px solid ${theme.palette.primary.main}`}}>
                    <Typography variant="caption" style={{ fontStyle: 'italic', marginBottom: 20 }}>
                        "Doy fe que se me ha explicado tanto el alcance como las consecuencias del desistimiento de la Ruta de atención de VBG."
                    </Typography>
                </Paper>
            </Grid>
        </Grid>
    );
}

export const FormularioDesistimientoSteps = [
    {
        label: 'Identificación y Representación',
        render: (props) => <DatosIdentificacion {...props} />
    }
];